import Reveal from './Reveal';
import './LegalContent.css';

export default function LegalContent({ intro, sections }) {
  const lastUpdated = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <section className="section legal-content">
      <div className="container legal-container">
        <Reveal as="p" className="legal-updated">Last updated: {lastUpdated}</Reveal>
        <Reveal as="p" className="legal-intro">{intro}</Reveal>

        {sections.map((section) => (
          <Reveal as="div" key={section.heading} className="legal-section">
            <h2>{section.heading}</h2>
            {section.paragraphs?.map((para) => (
              <p key={para}>{para}</p>
            ))}
            {section.list && (
              <ul>
                {section.list.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </Reveal>
        ))}
      </div>
    </section>
  );
}
